import { h } from 'preact'
import EventDateFormatter from './EventDateFormatter'
import { UserData } from './EventAttendees'
import EventAttendeesPreview from './EventAttendeesPreview'
import classNames from 'classnames'
import Icon from '../assets'
import Phrase from '../../libs/translationsUtils/phrase'
import { common } from '../common'

interface Event {
  id?: number
  image?: string
  startAt: number
  endAt: number
  title: string
  destinationUrl: string
  location?: string
  type?: string
  objectID?: string
  attendees?: UserData[]
  attendeeCount?: number
  isLoggedInUserAttendee?: boolean
}

interface EventPresentation extends Event {
  isFullWidth?: boolean
  isFeatured?: boolean
  key?: number
}

interface Props {
  eventList: Event[]
  className: string
}

const EventListView = ({ eventList, className }: Props) => {
  return (
    <div className={className}>
      {eventList.map(event => <EventListItemView key={event.id} {...event} />)}
    </div>
  )
}

export const EventListItemView = ({ id, title, type, startAt, endAt, image, location, destinationUrl, attendees, attendeeCount, isLoggedInUserAttendee, isFeatured, isFullWidth }: EventPresentation) => {
  const formattedStartAt = EventDateFormatter.formatStartAtForOverviewList(startAt)
  const isPastEvent = EventDateFormatter.isPastEvent(endAt)
  const isEventEngagementEnabled = common.isModuleActive('eventEngagement')
  return (
    <a href={destinationUrl} className={`event-list-item__url qa-event-list-item-url qa-event-${id ?? ''}`}>
      <div className={classNames({
        'featured-event__item': image && isFeatured && !isFullWidth,
        'event-list-item-container': image,
        'topic-view': !isFeatured,
        'event-list-item-details-full-width': !image,
        'card-widget-wrapper': true
      })}
      >
        {image &&
          <div className='event-item-image-container'>
            {type &&
              <span class={`${isPastEvent ? 'event-pill__past' : ''} event-item__type pill pill--uppercase pill--article qa-content-type-pill`}>
                {type}
              </span>}
            <div className='event-item__image' style={{ backgroundImage: `url(${image})` }} />
          </div>}
        <div className='event-item-detail-container'>
          <div className={`${isPastEvent ? 'event__date_past' : ''} event-item__date`}>
            {formattedStartAt}
          </div>
          <h3 className='event-item__title'>
            {type && !image &&
              <span class={`${isPastEvent ? 'event-pill__past' : ''} event-detail-item__type pill pill--uppercase pill--article qa-content-type-pill`}>
                {type}
              </span>}
            <a href={destinationUrl} className='event-item__title qa-event-title card-widget-title'>
              {title}
            </a>
          </h3>
          {location
            ? <div className='event-item__location'>
              <div className='event-item__location_icon'><Icon icon='people' /> </div>
              <div><Phrase p='events.location.in.person' m='Forum' /></div>
            </div>
            : <div className='event-item__location'>
              <div className='event-item__location_icon'><Icon icon='computer' /> </div>
              <div><Phrase p='events.location.online' m='Forum' /></div>
            </div>}
          <EventAttendeesPreview
            isPastEvent={isPastEvent}
            attendeeCount={attendeeCount}
            attendees={attendees}
            isLoggedInUserAttendee={isLoggedInUserAttendee}
            isEventEngagementEnabled={isEventEngagementEnabled}
          />
        </div>
      </div>
    </a>
  )
}
export default EventListView
